export const BM_EXPERIMENTS = {
  MOTO: 'specs.membership.EnableMoto',
  GIZA_PAGES_IN_BM: 'specs.membership.GizaPagesInBm',
  DEV_CENTER_FORM_CONFIGURATION: 'specs.membership.DevCenterFormConfiguration',
  BENEFIT_PROGRAMS: 'specs.membership.BenefitsPrograms',
  BOOKINGS_BENEFIT_PROGRAMS_DEMO: 'specs.membership.BookingsBenefitProgramsDemo',
  AI_ASSISTANT: 'specs.membership.PricingPlansAssistantEntryPoint',
  DEV_CENTER_SUBSCRIPTIONS_WIDGET: 'specs.membership.enableGizaWidgets',
  MULTIPLE_AI_ASSISTANTS: 'specs.membership.MultiplePricingPlansAssistants',
  FORMS_NEW_ADD_PANEL: 'specs.membership.FormsNewAddPanel',
  SHOW_FORM_EMPTY_VALUES: 'specs.membership.ShowFormEmptyValues',
  REMOVE_DONT_USE_FORM_OPTION: 'specs.membership.RemoveDontUseFormOption',
  SIGNATURE_FORM_FIELD: 'specs.membership.SignatureFormField',
  MULTILINE_ADDRESS_FIELD: 'specs.membership.MultilineAddressFormField',
  TAX_ID_FIELD: 'specs.membership.TaxIdFormField',
  RATING_FIELD: 'specs.membership.RatingFormField',
  DATE_PICKER_FIELD: 'specs.membership.DatePickerFormField',
  PLANS_MANAGE_MODAL_EMPTY_STATE: 'specs.membership.PlansManageModalEmptyState',
  SUBMISSION_EXTENSION: 'specs.membership.SubmissionExtension',
  WELCOME_PAGE_V2: 'specs.membership.WelcomePagev4',
  AI_DESCRIPTION: 'specs.membership.AiDescription',
  HANDLE_FORM_STATUS: 'specs.membership.HandleFormStatus',
  TEXT_AREA_FOR_DESCRIPTION: 'specs.membership.TextAreaForDescription',
  ECOM_INTEGRATION_ENABLED: 'specs.membership.EcomIntegrationEnabled'
};
//# sourceMappingURL=bm.js.map